import Seo from "@/components/common/Seo";
import { Link } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { faqList } from "@/mocks/manhua";

export default function FaqPage() {
  return (
    <>
      <Seo
        title="常见问题 - 韩漫大全在线阅读站"
        description="关于好看的韩漫大全哪个网站有、书源是否免费、如何追更与离线下载等常见问题解答，韩漫大全在线阅读站为你一一说明。"
        keywords="韩漫大全,常见问题,韩漫在线阅读,韩漫书源"
        canonical="https://hkmans1.github.io/faq"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqList.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }}
      />

      <div className="mx-auto w-full max-w-4xl px-4 py-8 md:py-12">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "常见问题" }]} />

        <div className="mt-5">
          <h1 className="heading-font text-2xl font-bold text-foreground-950 md:text-3xl">常见问题</h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            关于韩漫大全的使用与书源阅读，这里整理了读者最常问的问题。如果仍有疑问，欢迎通过页脚邮箱联系我们。
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {faqList.map((f, i) => (
            <details key={f.q} open={i === 0} className="group rounded-2xl border border-background-200/70 bg-background-100 p-5">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-3 text-sm font-bold text-foreground-950 md:text-base">
                <span>{f.q}</span>
                <i className="ri-add-line text-xl text-foreground-500 transition-transform group-open:rotate-45" />
              </summary>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{f.a}</p>
            </details>
          ))}
        </div>

        <div className="mt-10 rounded-2xl bg-secondary-100 p-6 text-center">
          <h2 className="heading-font text-lg font-bold text-foreground-950">没找到答案？</h2>
          <p className="mt-2 text-sm text-foreground-600">去书源推荐页挑一个稳定站点开始阅读，或联系我们获取帮助。</p>
          <Link
            to="/shuyuan"
            className="mt-4 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-2.5 text-sm font-bold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            <i className="ri-magic-line" /> 查看书源推荐
          </Link>
        </div>
      </div>
    </>
  );
}